import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup, Validators,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO, MessageLevel,} from '@models/index';
import {Logger,
        LoginInfoService,
        MessageStackService,
        MessageProvider,
        ScreenMessageHandler,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS001MainMenuInVO,} from '@pages/sms001-main-menu/sms001-main-menu-in-vo';
import {SMS001MainMenuOutVO,} from '@pages/sms001-main-menu/sms001-main-menu-out-vo';
import {SMS001MainMenuDispVO,} from '@pages/sms001-main-menu/sms001-main-menu-disp-vo';
import * as Const_SMS001 from '@pages/sms001-main-menu/sms001-main-menu-const';
import {SMS002KeiyakuInfoInVO,} from '@pages/sms002-keiyaku-info/sms002-keiyaku-info-in-vo';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms001-main-menu',
  templateUrl: './sms001-main-menu.html',
  styleUrls: ['./sms001-main-menu.scss',],
})
/*****************************************************/
/* 処　理：SMS001 メインメニュー 画面
/*
/* 概　要：用件選択・本人認証 処理
/*
/* 更新日：2025/03/13 HARAGU 00011_SMS機能等の導入支援_#10094
/*****************************************************/
export class SMS001MainMenu implements OnInit {
  smsForm!: FormGroup;                  // 画面フォーム
  loginUserVO!: LoginUserVO;            // セッション情報
  sms001InfoVO!: SMS001MainMenuInVO;    // POSTパラメータ
  dispId!: string;                      // ログ表示用ID
  lngType!: string;                     // 言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // その他メニュー表示・非表示 設定用
  sonotaMenuVisibility = 'visible';

  // 画面項目（ラベル入れ替え用）
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblMessage04!: string;
  public lblMessage05!: string
  public lblMessage06!: string;
  public lblMessage07!: string;
  public lblMessage08!: string;
  public lblMessage09!: string;
  public lblSubmit!: string;
  public lblScreenName!: string;

  isEnableBtnSubmit = true;

  // 取引メニュー設定用
  torihikiMenuVO: SMS001MainMenuDispVO[] = [];
  // その他メニュー設定用
  sonotaMenuVO: SMS001MainMenuDispVO[] = [];
  // 言語プルダウン設定用
  langTypeVO: SMS001MainMenuDispVO[] = [];

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private loginInfoService: LoginInfoService,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    private titleService: Title,
    private screenMessage: ScreenMessageHandler,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const postVo: SMS001MainMenuInVO = this.windowService.getItemFromLocalStorage<SMS001MainMenuInVO>('SMS001')!;
    if (postVo) {
      // POSTパラメータを取得
      this.sms001InfoVO = postVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.sms001InfoVO.hashId;
      this.lngType = this.sms001InfoVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00101M005E');

      // POSTパラメータが取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   *  初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
      optlanguageType: ['01',],
      rdoMenuShbt: ['',],
      txtBirthday: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(8),
          this.validationService.dateYYYYMMDDValidator(),
        ],
      ],
    });

    // 初期表示
    this.formInit();
  }


  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00101M001I', Const_SMS001.INIT_NAME, this.dispId);

      // ログ出力（POSTパラメータ）
      this.logger.debug('■ 01 POSTパラメータ');
      this.logger.debug('■ 01  hashId      ：' + this.sms001InfoVO.hashId);
      this.logger.debug('■ 01  menuNo      ：' + this.sms001InfoVO.menuNo);
      this.logger.debug('■ 01  languageType：' + this.sms001InfoVO.languageType);

      // 初期表示 画面情報設定
      this.getInitApiReturnInfo();

      // 初期化（パラメータ情報）
      this.windowService.removeItemFromLocalStorage('SMS002');
      this.windowService.removeItemFromLocalStorage('SMS008');
      this.windowService.removeItemFromLocalStorage('SMS011');
      // 初期化（ログイン情報）
      this.windowService.removeItemFromLocalStorage('accToken');
      this.windowService.removeItemFromLocalStorage('loginInfo');

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00101M002I', Const_SMS001.INIT_NAME, this.dispId);

    } catch (ex) {
      this.logger.error('SMS00101M001E', Const_SMS001.INIT_NAME, this.dispId);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示 画面情報設定
   *
   * ※接続認証がまだなので、汎用マスタから取得できないのでメッセージから設定する
   *
   * @returns -
   */
  getInitApiReturnInfo(): void {

    this.logger.debug('■ 01 start-- getInitApiReturnInfo');

    //----------------------------------------------
    // 言語プルダウン設定
    //----------------------------------------------
    let i: number;
    let msg: string | null;

    // 定数：対応言語数分、繰り返し
    for (i = 1; i <= Const_SMS001.LANG_TYPE_UPPER_LIMIT; i++) {
      // メッセージID：SMS999xxM999F を取得
      msg = this.messageProvider.getMessageString({messageId: 'SMS999' + String(i).padStart(2, '0') + 'M999L',},  false);

      if (msg != null) {
        // 取得出来たらプルダウンに追加
        this.langTypeVO.push({id: String(i).padStart(2, '0'), name: msg,});
      } else {
        // 取得出来なかったらループを抜ける
        break;
      }
    }

    // 言語プルダウンの値設定
    this.smsForm.get('optlanguageType')?.setValue(this.lngType);
    this.logger.debug('■ 01 set languageType：' + this.smsForm.get('optlanguageType')?.value);

    // 画面文言設定（文言は、/models/system-vo/message-origin.ts 参照）
    const lblRadioName: string[][] = [];
    const lblName1: string[] = [];
    lblName1.push('01', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M021F',},  false) || '');
    lblRadioName.push(lblName1);
    const lblName2: string[] = [];
    lblName2.push('02', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M022F',},  false) || '');
    lblRadioName.push(lblName2);
    const lblName3: string[] = [];
    lblName3.push('03', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M023F',},  false) || '');
    lblRadioName.push(lblName3);
    const lblName4: string[] = [];
    lblName4.push('04', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M024F',},  false) || '');
    lblRadioName.push(lblName4);
    const lblName5: string[] = [];
    lblName5.push('05', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M025F',},  false) || '');
    lblRadioName.push(lblName5);
    const lblName6: string[] = [];
    lblName6.push('06', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M026F',},  false) || '');
    lblRadioName.push(lblName6);
    const lblName7: string[] = [];
    lblName7.push('07', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M027F',},  false) || '');
    lblRadioName.push(lblName7);
    const lblName8: string[] = [];
    lblName8.push('08', this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M028F',},  false) || '');
    lblRadioName.push(lblName8);

    // ラジオボタン振り分け設定
    if ('99' === this.sms001InfoVO.menuNo) {
      // 全て 取引メニューに追加
      for (const lblNames of lblRadioName) {
        // 取引メニューに追加
        this.torihikiMenuVO.push({id: lblNames[0], name:lblNames[1],});
      }

      // 全項目対応の場合、その他メニューを非表示
      this.sonotaMenuVisibility = 'hidden';

    } else {
      // 対象のもののみ 取引メニューに追加（対象でないものはその他メニューに追加）
      let i = 0;
      for (const lblNames of lblRadioName) {
        if (this.sms001InfoVO.menuNo === lblNames[0]) {
          // 一致した場合、取引メニューに追加
          this.torihikiMenuVO.push({id: lblNames[0], name:lblNames[1],});
        } else {
          // 一致しない場合、その他メニューに追加
          this.sonotaMenuVO.push({id: lblNames[0], name:lblNames[1],});
        }
        i = i + 1;
      }
    }

    // 取引メニュー ラジオボタンデフォルト設定
    if ('99' === this.sms001InfoVO.menuNo) {
      this.smsForm.get('rdoMenuShbt')?.setValue('01');
    } else {
      this.smsForm.get('rdoMenuShbt')?.setValue(this.sms001InfoVO.menuNo);
    }
    this.logger.debug('■ 01 set rdoMenuShbt：' + this.smsForm.get('rdoMenuShbt')?.value);

    // ラベル設定（文言は、/models/system-vo/message-origin.ts 参照）
    // オリコフォレントインシュアでございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M001F',},  false) || '';
    // 貴殿がご契約された内容を下記項目から選択して確認ください。
    this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M002F',},  false) || '';
    // 取引メニュー
    this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M003F',},  false) || '';
    // お支払いに関する項目
    this.lblMessage04 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M004F',},  false) || '';
    // その他
    this.lblMessage05 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M005F',},  false) || '';
    // 本人確認を行います。
    this.lblMessage06 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M006F',},  false) || '';
    // 生年月日を西暦で年月日の形式でご入力ください。
    this.lblMessage07 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M007F',},  false) || '';
    // 生年月日
    this.lblMessage08 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M008F',},  false) || '';
    // YYYYMMDD
    this.lblMessage09 = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M009F',},  false) || '';
    // 取引を行う
    this.lblSubmit = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M010F',},  false) || '';

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS001' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    this.lblScreenName = screenName;

    this.logger.debug('■ 01 end---- getInitApiReturnInfo');
    return;
  }

  /** *************************************************************
   * 言語プルダウン切替
   * **************************************************************
   * @param {string} value 言語プルダウン選択値
   */
  onChangeLangType(value:string): void {
    try {
      // ログ出力
      this.logger.info('SMS00101M001I', Const_SMS001.CHANGE_LANGUAGE_NAME, this.dispId);
      this.logger.debug('■ 01 onChangeLangType：' + value);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.sms001InfoVO.hashId,
                                  this.sms001InfoVO.menuNo,
                                  value);

    } catch (ex) {
      this.logger.error('SMS00101M001E', Const_SMS001.CHANGE_LANGUAGE_NAME, this.dispId);
      this.commonException(ex);
    }
  }

  /* **************************************************************
   * 取引を行うボタン押下
   * **************************************************************/
  executeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00201M006I', Const_SMS001.BTN_EXECUTE_NAME, this.dispId);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック
      if (!this.inputCheck()) {
        return;
      }

      // 画面項目制御
      this.enabledChange(false);

      // 認証API 呼出
      this.doExecute(Const_SMS001.API_EXECUTE_PATH, Const_SMS001.BTN_EXECUTE_NAME);

    } catch (ex) {
      this.logger.error('SMS00101M002E', Const_SMS001.BTN_EXECUTE_NAME, this.dispId);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック
   * @returns true/false
   */
  inputCheck(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug('■ 01 入力チェック開始');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 取引メニュー
    if (this.smsForm.get('rdoMenuShbt')?.value === '') {
      this.logger.debug('■ 01 取引メニュー：必須NG');
      isRet = false;
    }
    // 生年月日
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtBirthday.value)) {
      this.logger.debug('■ 01 生年月日：必須NG');
      this.smsForm.controls.txtBirthday.setErrors({required: true,});
      this.smsForm.controls.txtBirthday.markAsDirty();
      isRet = false;
    }

    // ------------------------------------------
    // 日付型の整合性チェック
    // ------------------------------------------
    if (!this.validationService.isDateYYYYMMDD(this.smsForm.controls.txtBirthday.value)) {
      this.logger.debug('■ 01 生年月日：isDateYYYYMMDD NG');
      this.smsForm.controls.txtBirthday.setErrors({isDateYYYYMMDD: true,});
      this.smsForm.controls.txtBirthday.markAsDirty();
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug('■ 01 入力チェック終了');

    return isRet;
  }

  /**
   * 認証API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  doExecute(path: string, btnName: string) {

    // ログ出力
    this.logger.info('SMS00101M001I', btnName, this.dispId);
    this.logger.debug('■ 01 start-- doExecuteAPI');

    // APIパラメータ設定
    const apiVo = {
      hashId: this.sms001InfoVO.hashId,
      birthday: this.smsForm.controls.txtBirthday.value,
      menuNo: this.sms001InfoVO.menuNo,
      languageType: this.sms001InfoVO.languageType,
    }

    // ログ出力（API入力情報）
    this.logger.debug('■ 01 URL：[' + path + ']');
    this.logger.debug('■ 01 ApiIn   hashId      ：' + apiVo.hashId);
    this.logger.debug('■ 01 ApiIn   birthday    ：' + apiVo.birthday);
    this.logger.debug('■ 01 ApiIn   menuNo      ：' + apiVo.menuNo);
    this.logger.debug('■ 01 ApiIn   languageType：' + apiVo.languageType);

    // 認証API
    this.logger.info('SMS00101M003I', btnName, this.dispId);
    this.httpClient.post<SMS001MainMenuOutVO>(path, apiVo).subscribe({
      next: (resp: SMS001MainMenuOutVO) => {
        this.logger.info('SMS00101M004I', this.dispId);
        if (resp != null) {
          // API返却情報取得（接続情報 設定）
          this.getExecApiReturnInfo(resp);
          // 接続情報設定（トークン情報を設定する）
          this.loginInfoService.setLoginUserInfo(this.loginUserVO);
          // 画面遷移
          this.nextPage();

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00101M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;

      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00101M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 01 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 認証API返却情報 取得（接続情報 設定）
   *
   * @param {SMS001MainMenuOutVO} resp
   * @returns -
   */
  getExecApiReturnInfo(resp: SMS001MainMenuOutVO): void {
    // APIからの返却情報 取得 - 接続情報 設定
    this.logger.debug('■ 01 APIからの返却情報 取得 開始');

    // 接続情報 取得
    this.loginUserVO = resp['loginUserInfoVO'];
    // 画面情報 取得
    this.loginUserVO.menuNo = this.sms001InfoVO.menuNo;
    this.loginUserVO.languageType = this.sms001InfoVO.languageType;

    // ログ出力（API返却情報）
    this.logger.info('SMS00101M005I', 'ハッシュ値', '言語区分', 'メニュー番号', '契約情報ID', '番号');
    this.logger.info('SMS00101M005I', this.loginUserVO?.hashId, this.loginUserVO?.languageType, this.loginUserVO?.menuNo, this.loginUserVO?.keiyakuInfoId, this.loginUserVO?.shouninNo);

    this.logger.debug('■ 01 APIからの返却情報 取得 終了');
    return;
  }

  /**
   * 画面遷移処理
   */
  nextPage(): void{

    const info002Vo: SMS002KeiyakuInfoInVO = new SMS002KeiyakuInfoInVO();

    this.logger.debug('■ 01 画面遷移');
    this.logger.debug('■ 01 rdoMenuShbt：' + this.smsForm.get('rdoMenuShbt')?.value);

    // 画面ID設定
    const rdoValur: string = this.smsForm.get('rdoMenuShbt')?.value;
    if ('01' === rdoValur) {
      info002Vo.screenId = 'SMS005';      // 家賃残高・口座の確認 画面
    } else if ('02' === rdoValur) {
      info002Vo.screenId = 'SMS003';      // 支払日確認登録 画面
    } else if ('03' === rdoValur) {
      info002Vo.screenId = 'SMS004';      // バーコード用リンク 画面
    } else if ('04' === rdoValur) {
      info002Vo.screenId = 'SMS006';      // 翌月家賃等請求額確認 画面
    } else if ('05' === rdoValur) {
      info002Vo.screenId = 'SMS007';      // 解約・退去の登録 画面
    } else if ('06' === rdoValur) {
      info002Vo.screenId = 'SMS009';      // 氏名変更 画面
    } else if ('07' === rdoValur) {
      info002Vo.screenId = 'netkouza';    // 外部URL（ネット口座振替受付サービス ）
    } else if ('08' === rdoValur) {
      info002Vo.screenId = 'netkouza';    // 外部URL（ネット口座振替受付サービス ）
    }

    this.logger.debug('■ 01 screenId：' + info002Vo.screenId);
    this.logger.debug('■ 01 → 02 画面遷移');

    this.windowService.transit<SMS002KeiyakuInfoInVO>('SMS002', info002Vo);
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug('■ 01 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.sms001InfoVO.hashId,
                               this.sms001InfoVO.menuNo,
                               this.sms001InfoVO.languageType);
  }

  /**
   * 画面項目の制御
   * @param {boolean} isEnabledFlg
   */
  enabledChange(isEnabledFlg: boolean): void {
    this.isEnableBtnSubmit = isEnabledFlg;
  }

}
